import { TargetSystem } from '@/shared/constants'

type RawPath = string | string[]

const baseUrls = {
  [TargetSystem.CoreApi]: new URL(import.meta.env.VITE_API_BASE_URL),
  [TargetSystem.Core]: new URL(import.meta.env.VITE_CORE_URL),
  [TargetSystem.AssetManagement]: new URL(import.meta.env.VITE_ASSET_MANAGEMENT_API_URL)
} as const

/**
 * Build a URL to the target Unifii system.
 *
 */
export function buildUrl(to: TargetSystem, path: RawPath = '') {
  return new URL(normalisePath(path), baseUrls[to])
}

/**
 * Normalises a given path.
 *
 * If the path is an array, each part is URL-encoded and joined together.
 * If the path is a string, any leading slashes are stripped off.
 *
 */
export function normalisePath(path: RawPath) {
  if (typeof path === 'string') {
    return path.replace(/^\/+/, '')
  } else {
    return path.map(v => encodeURIComponent(v)).join('/')
  }
}

export function navigateToUrl(system: TargetSystem, path: RawPath) {
  window.location.href = buildUrl(system, path).toString()
}
